import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const joinoffcreqAdapter = createEntityAdapter({})

const initialState = joinoffcreqAdapter.getInitialState()

export const joinoffreqApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getjoinoffreq: builder.query({
            query: () => ({
                url: '/joinoffreq',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedjoinoffreq = responseData.map(joinoffreq => {
                    // console.log(emailmaster)
                    joinoffreq.id = joinoffreq._id
                    // console.log(emailmaster)
                    return joinoffreq
                });
                return joinoffcreqAdapter.setAll(initialState, loadedjoinoffreq)
            },
            providesTags: (result, error, arg) => {
                console.log(result.ids) 
                if (result?.ids) {
                    return [
                        { type: 'JOINOFFREQ', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'JOINOFFREQ', id }))
                    ]
                } else return [{ type: 'JOINOFFREQ', id: 'LIST' }]
            }
        }),
        addNewjoinoffreq: builder.mutation({
            query: initialUserData => ({
                url: '/joinoffreq',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'JOINOFFREQ', id: "LIST" }
            ]
        }),
        updatejoinoffreq: builder.mutation({
            query: initialUserData => ({
                url: '/joinoffreq',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'JOINOFFREQ', id: arg.id }
            ]
        }),        
        deletejoinoffreq: builder.mutation({
            query: ({ id }) => ({
                url: `/joinoffreq`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'JOINOFFREQ', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetjoinoffreqQuery,
    useAddNewjoinoffreqMutation,
    useUpdatejoinoffreqMutation,
    useDeletejoinoffreqMutation,
} = joinoffreqApiSlice

// returns the query result object
export const selectjoinoffreqResult = joinoffreqApiSlice.endpoints.getjoinoffreq.select()

// creates memoized selector
const selectjoinoffreqData = createSelector(
    selectjoinoffreqResult,
    joinoffreqResult => joinoffreqResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAlljoinoffreq,
    selectById: selectjoinoffreqById,
    selectIds: selectjoinoffreqIds,
    // Pass in a selector that returns the users slice of state
} = joinoffcreqAdapter.getSelectors(state => selectjoinoffreqIds(state) ?? initialState)